import { FreightType, Price } from "@utils/interfaces";

/**
 * Regra 9: Se FOB mostra só preço base, se CIF soma preço + frete.
 */
export function calculateDisplayPrice(
  price: Price | null,
  freightType: FreightType | null
): number {
  if (!price) return 0;
  if (!freightType) return 0;
  return freightType === "FOB" ? price.price : price.price + price.freight;
}

/**
 * Regra 8: Determina o prazo de pagamento inicial do produto.
 */
export function getInitialDeadlinePayment(
  productPayCond: number | undefined,
  customerPayCond: number | undefined
): number {
  return productPayCond || customerPayCond || 0;
}
